/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_EmptyInputs */

const en_users_empty = /** @type {(inputs: Users_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No users in this list yet.`)
};

const pt_br2_users_empty = /** @type {(inputs: Users_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum usuário nesta lista ainda.`)
};

/**
* | output |
* | --- |
* | "No users in this list yet." |
*
* @param {Users_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_empty = /** @type {((inputs?: Users_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_empty(inputs)
	return pt_br2_users_empty(inputs)
});